<template>
  <div class="container">
    <template v-if="records.length">
      <RefundRecordItem v-for="item in records" :key="item.refundId" :data="item" />
    </template>

    <div v-else class="not-data">
      <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
      <div class="tips-text">{{ $t('Order.Refund.Mobile.Components.RefundRecord.NoRecord') }}</div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import RefundRecordItem from './RefundRecordItem.vue'

export default {
  components: {
    RefundRecordItem
  },
  data() {
    return {
      records: []
    }
  },
  created() {
    this.getOrderRefundRecord(this.$route.query.kakaOrderId)
  },
  methods: {
    /**
     * API 获取订单退款记录
     *
     * @param {Number} kkOrderId
     */
    async getOrderRefundRecord(kkOrderId) {
      let { data } = await API.getOrderRefundRecord(kkOrderId)
      this.records = data || []
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 15px;
  background-color: #fff;
  .not-data {
    text-align: center;
    .tips-text {
      margin-top: 20px;
    }
  }
}
</style>
